<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>

  <ng-container *ngIf="!boundImport && !isLoading">
    <mat-card appearance="outlined">
      <mat-card-title>Comming Soon</mat-card-title>
      <p>This Form is not yet editable</p>
    </mat-card>
  </ng-container>

  <ng-container>
    <div class="form-container">
      <ng-template formHost></ng-template>
    </div>
    <button (click)="onSave()" mat-button>Save</button>
  </ng-container>


</page-content>
